import { getDetailNotification, getNotificationActive, getNotificationDraft, notificationDelete, postNotification, postOrderingNotification, putNotification } from '../../utils/api';
import { actionTypes, notificationType } from './constants';

export function setFailedAction({ key, message, error }) {
  return { type: actionTypes.FAILED, key, message, error };
}

export function setLoadingAction({ key, loading = true }) {
  return { type: actionTypes.LOADING, key, loading };
}

export function setSuccessAction({
  key,
  data,
  meta = {},
  initial = true,
  message = '',
  success = true
}) {
  return { type: actionTypes.SUCCESS, key, data, meta, initial, message, success };
}

export function fetchNotification(nextpage, search, initial = true) {
  return async (dispatch, getState) => {
    const key = 'dataNotification';
    const state = getState();
    const { page, totalPage } = state.notification.dataNotification.meta;
    if (!initial && page > 1 && page >= totalPage) {
      return;
    } else {
      try {
        const params = {
          search,
          size: 100,
          page: nextpage,
        };
        dispatch(setLoadingAction({ key }));
        const response = await getNotificationDraft(params);
        const data = initial ?
          response.data : [...state.notification.dataNotification.data, ...response.data];
        dispatch(setSuccessAction({ key, data, meta: response.meta, initial }));
      } catch (error) {
        const { message } = error;
        dispatch(setFailedAction({ key, message }));
      }
    }
  };
}

export function fetchActiveNotification() {
  return async (dispatch) => {
    const key = 'dataActiveNotification';
    try {
      dispatch(setLoadingAction({ key }));
      const { data } = await getNotificationActive();
      dispatch(setSuccessAction({ key, data }));
      dispatch(setSuccessAction({ key: 'addNotification', success: false }));
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function fetchDeleteNotification(id) {
  return async (dispatch) => {
    const key = 'deleteNotification';
    try {
      dispatch(setLoadingAction({ key }));
      const { data } = await notificationDelete(id);
      dispatch(setSuccessAction({ key, data }));
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function postOrderingNotificationActive(payload) {
  return async (dispatch) => {
    const key = 'orderActiveNotification';
    try {
      dispatch(setLoadingAction({ key }));
      const { data } = await postOrderingNotification(payload);
      dispatch(setSuccessAction({ key, data }));
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function createNotification(type, payload) {
  return async (dispatch) => {
    const key = 'addNotification';
    try {
      dispatch(setLoadingAction({ key }));
      const { data } = await postNotification(notificationType[type], payload);
      dispatch(setSuccessAction({ key, data }));
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function updateNotification(id, type, payload) {
  return async (dispatch) => {
    const key = 'addNotification';
    try {
      dispatch(setLoadingAction({ key }));
      const { data } = await putNotification(id, notificationType[type], payload);
      dispatch(setSuccessAction({ key, data }));
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function fetchNotificationById(id) {
  return async (dispatch) => {
    const key = 'detailNotification';
    try {
      dispatch(setLoadingAction({ key }));
      const { data } = await getDetailNotification(id);
      dispatch(setSuccessAction({ key, data }));
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}
